import { createAsyncThunk } from "@reduxjs/toolkit";

import * as URL from "helpers/url_helper";
import { get, newGet, newPost, post, put } from "helpers/api_helper";
import { toast } from "react-toastify";
import { getValuesSocketData } from "helpers/secretManager";

export const getUserStatistics = createAsyncThunk(
  "getUserStatistics",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await newPost(URL.GET_USER_STATISTICS, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message); // ✅ important
      }

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error?.message || error);
    }
  },
);

export const getBtncStatistics = createAsyncThunk(
  "getBtncStatistics",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await newPost(URL.GET_BTNC_STATISTICS, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message); // ✅ important
      }

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error?.message || error);
    }
  },
);

export const getEnergyStatistics = createAsyncThunk(
  "getEnergyStatistics",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await newPost(URL.GET_ENERGY_STATISTICS, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message); // ✅ important
      }

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error?.message || error);
    }
  },
);

export const getClaimStatistics = createAsyncThunk(
  "getClaimStatistics",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await newPost(URL.GET_CLAIM_STATISTICS, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message); // ✅ important
      }

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error?.message || error);
    }
  },
);

export const getTaskStatistics = createAsyncThunk(
  "getTaskStatistics",
  async ({ data, callback }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData();

      const response = await newPost(URL.GET_TASK_STATISTICS, data, {
        signature,
        nonce,
      });

      if (response?.status === "failure") {
        callback && callback(response?.message, null);
        return Thunk.rejectWithValue(response?.message); // ✅ important
      }

      callback && callback(null, response.data);
      return response.data;
    } catch (error) {
      callback && callback(error);
      return Thunk.rejectWithValue(error?.message || error);
    }
  },
);
